import { Link } from 'react-router-dom';
import { successionSentence, t, type CompanySuccession, type SuccessionLink } from '@bms2/shared';
import styles from './SuccessionSentence.module.css';

/** A company the sentence names: a link where the server gave a route, plain text where it did not (decision 2153). */
function Named({ company }: { company: SuccessionLink }) {
  return company.route
    ? <Link className={styles.link} to={company.route} data-succession-company={company.id}>{company.name}</Link>
    : <span className={styles.link} data-succession-company={company.id}>{company.name}</span>;
}

/**
 * 🔒 Who bought this company and whom it bought, beside the status pill (decision 7690; T3141). A Bought Out company reads
 * *Bought out by* its successor; a company that is the successor of one reads *Formerly* the old name, and of several reads
 * *Formerly N companies* with each name in a list. Nothing draws where the company has neither.
 */
export function SuccessionSentence({ succession }: { succession: CompanySuccession | null | undefined }) {
  if (!succession || (!succession.boughtOutBy && succession.formerly.length === 0)) return null;
  const { boughtOutBy, formerly } = succession;
  return (
    <>
      {boughtOutBy ? (
        <span className={styles.sentence} data-company-succession="boughtOutBy">
          <span>{t('succession.boughtOutBy')}</span>
          <Named company={boughtOutBy} />
        </span>
      ) : null}
      {formerly.length === 1 ? (
        <span className={styles.sentence} data-company-succession="formerly">
          <span>{t('succession.formerly')}</span>
          <Named company={formerly[0]!} />
        </span>
      ) : null}
      {formerly.length > 1 ? (
        <span className={styles.sentence} data-company-succession="formerly">
          <span>{successionSentence('succession.formerlyMany', { count: String(formerly.length) })}</span>
          <ul className={styles.list} data-company-succession-list="true">
            {formerly.map((company) => <li key={company.id}><Named company={company} /></li>)}
          </ul>
        </span>
      ) : null}
    </>
  );
}
